export default function SearchBox({ value, onChange, placeholder }) {
  return (
    <input
      type="text"
      className="form-control"
      placeholder={placeholder || "Search..."}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
